import http from "../../http-common";

class ProductRightSideLearningService {
    getProductRightSideLearningService(productPath: string) {
        return http.get(`/right-side-section/products/learning/${productPath}`);
    }
}

export default new ProductRightSideLearningService();
